
import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bg1 from "../assets/img/bg.jpg";
import { Link } from "react-router-dom";
import { useAppKitAccount } from "@reown/appkit/react";
import logo from "../assets/img/logo.png";
import { getSponsor, registerWithAPIWallet } from "../api/apiService";
import { useToken } from "../components/TokenContext";
import AlertMessage from "../components/AlertMessage";
import { useLocation, useNavigate } from "react-router-dom";
import { BNBUSDTContract, USDTContract } from "../config/contractConfig";
import USDTABI from "../abis/USDTABI.json";
import BNBUSDTContractABI from "../abis/BNBUSDTContractABI.json";
import Web3 from "web3";
import { useConnectorClient, useSwitchChain } from "wagmi";
import TermCondition from "../components/TermCondition.jsx";
const Register = () => {
    const [acceptTerms, setAcceptTerms] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [isApproved, setIsApproved] = useState(false); // 🔥 MAIN STATE
  const [sponsor, setSponsor] = useState("");
  const { data: client } = useConnectorClient();
  const [web3, setWeb3] = useState(null);
  const [showGetSponsor, setShowGetSponsor] = useState(true);
  const [showSponsor, setShowSponsor] = useState(true);
  const { address, isConnected, chainId } = useAppKitAccount();
  const [reactalert, setAlert] = useState({ type: "", message: "" });
  const { token, fetchToken } = useToken();
  const navigate = useNavigate();
const [packageId, setpackageId] = useState("");
const [packageAmount , setpackageAmount ] = useState("");
const [approving, setApproving] = useState(false);
  useEffect(() => {
    const initWeb3 = () => {
      let provider = null;

      if (client && client.transport) provider = client.transport;
      else if (typeof window !== "undefined" && window.ethereum) provider = window.ethereum;

      if (!provider) return setWeb3(null);

      const w3 = new Web3(provider);
      setWeb3(w3);
    };

    initWeb3();
  }, [client]);

  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const referral = params.get("Referralcode");
    if (referral && referral.trim() !== "") {
      setSponsor(referral);
      setShowGetSponsor(false);
      setShowSponsor(true);
    } else {
      setShowGetSponsor(true);
      setShowSponsor(false);
    }
  }, [location.search]);


  useEffect(() => {
    if (!token) {
      fetchToken(); // Optional: Refetch If Token Is Null
    }
  }, [token]);

  const handleRegister = async () => {
     if (!isApproved) {
      setAlert({ type: "error", message: "Please approve first!" });
      return;
    }
   const pid=packageId-1;
    const requiredAmount = web3.utils.toWei(packageAmount, "ether");
  const contractInstance = new web3.eth.Contract(BNBUSDTContractABI,BNBUSDTContract);
  await contractInstance.methods.register(sponsor, pid, requiredAmount).send({ from: address });
  setAlert({
    type: "success",
    message: "Registration Complete! You can now login.",
  });

   setTimeout(() => {
     navigate("/");
   }, 3000);
};


const handleApprove = async (e) => {
  e.preventDefault();

  // ---------------- VALIDATIONS ----------------
  if (!sponsor) {
    setAlert({ type: "error", message: "Please enter Sponsor ID!" });
    return;
  }

  if (!address) {
    setAlert({ type: "error", message: "Wallet not connected!" });
    return;
  }

  if (!packageId) {
    setAlert({ type: "error", message: "Please select a package!" });
    return;
  }

  if (!packageAmount) {
    setAlert({ type: "error", message: "Please enter amount!" });
    return;
  }

  const amt = Number(packageAmount);
  if (isNaN(amt) || amt <= 0) {
    setAlert({ type: "error", message: "Invalid amount!" });
    return;
  }

  if (amt % 50 !== 0) {
    setAlert({
      type: "error",
      message: "Amount must be a multiple of 50",
    });
    return;
  }
 if (!acceptTerms) {
      setAlert({ type: "error", message: "Please accept Terms & Conditions!" });
      return;
    }
  try {
    setApproving(true);
    // ---------------- TOKEN CHECK ----------------
    let currentToken = token;
    if (!currentToken) {
      currentToken = await fetchToken();
      if (!currentToken) return;
    }

    // ---------------- USDT CONTRACT ----------------
    const usdt = new web3.eth.Contract(USDTABI, USDTContract);

    // const allowance = await usdt.methods
    //   .allowance(address, BNBUSDTContract)
    //   .call();

    const requiredAmount = web3.utils.toWei(packageAmount, "ether");

    // ---------------- APPROVE IF REQUIRED ----------------
    // if (Number(allowance) < Number(requiredAmount)) {
    //   setAlert({ type: "info", message: "Approval required..." });

      await usdt.methods.approve(BNBUSDTContract, requiredAmount).send({ from: address });

      setAlert({
        type: "success",
        message: "Approval successful. Please click the Register button to continue !",
        
      });
      setIsApproved(true);
    //}

    // ---------------- REGISTER ----------------
    //await registerNow();

  }  catch (err) {
      if (err?.code === 4001) {
        setAlert({ type: "error", message: "Transaction rejected by user" });
      } else {
        setAlert({ type: "error", message: err?.message || "Approval failed" });
      }
    } finally {
      setApproving(false); // 🔥 ENABLE BACK IF FAILED
    }
  };




  const handleGetSponsor = async () => {
    try {
      const data = await getSponsor(token);

      if (data?.status && data?.data) {
        setSponsor(data.data);
      }
      else {
        setAlert({ type: "error", message: "Failed to fetch sponsor ID" });
      }
    }
    catch (err) {
      console.error("Sponsor API error:", err);
      setAlert({ type: "error", message: "Failed to fetch sponsor ID" });
    }
  };


  return (

    <>

      <img src={bg1} alt="" className="bg-login" />

      <span className="game_bg_1"></span>
      <span className="game_bg_2"></span>
      <span className="game_bg_3"></span>
      <span className="game_bg_4"></span>

      <div className="login-5 register-page">

        <div className="card-login">

          <div className="logo-wrp">
            <img src={logo} alt="" className="logo-pic" />
{/* 
            <h3 className="text-white">    Hi, Welcome Back! 👋</h3> */}

            <h5 className="text-white">Register Into Your Account</h5>
          </div>






          {/* Tab Content */}
          <div className="tab-content">


            {/* Wallet Connect Tab */}

            <div className="tab-pane fade show active">
         

                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label Sponsor-wrp">
                        Sponsor ID{" "}
                        {showGetSponsor && (
                          <span
                            className="get-Sponsor"
                            style={{ cursor: "pointer" }}
                            onClick={handleGetSponsor}
                            disabled={showGetSponsor}
                          >
                            Get Sponsor
                          </span>
                        )}
                      </label>
                      <div className="icon-with-input">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Sponsor ID"
                          value={sponsor}
                          onChange={(e) => setSponsor(e.target.value)}
                          disabled={showSponsor}
                          required
                        />
                        <span className="wallet-span">  <i className="fa-solid fa-users icontop"></i></span>
                      </div>
                    </div>
                  </div>


                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Wallet Address  <sup className="text-warning">*</sup></label>
                      <div className="icon-with-wallet">
                        <w3m-button />

                      </div>
                    </div>
                  </div>

                </div>
                {reactalert.message && (
                  <AlertMessage
                    type={reactalert.type}
                    message={reactalert.message}
                    onClose={() => setAlert({ type: "", message: "" })}
                  />
                )}

                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Select Packages  <sup className="text-warning">*</sup></label>
                   <select
                    className="form-control pacakge-form"
                    value={packageId}
                    onChange={(e) => setpackageId(e.target.value)}
                  >
                    <option value="">Select Package</option>
                    <option value="1">STARTER PACKAGE $50 - $500</option>
                    <option value="2">BASIC PACKAGE $501 - $2000</option>
                    <option value="3">STANDARD PACKAGE $2001 - $5000</option>
                    <option value="4">PREMIUM PACKAGE $5001 - $10000</option>
                  </select>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Enter Amount  <sup className="text-warning">*</sup></label> 
                    <div className="price-input registration-input">
                      <i className="fa-solid fa-dollar-sign"></i>
                     <input
  className="form-control"
  placeholder="Enter amount"
  value={packageAmount }
  onChange={(e) => setpackageAmount (e.target.value.replace(/\D/g, ""))}
/>
                    </div>
                  </div>
                </div>

                    {/* TERMS */}
           <div className="col-md-12 mt-2">
  <div
    className="ms-2 text-white d-flex gap-2 align-items-center"
    style={{ cursor: "pointer" }}
    onClick={() => setShowTerms(true)}
  >
    <input
      type="checkbox"
      checked={acceptTerms}
      readOnly
    />
    <span>
      I accept the{" "}
      <span style={{ color: "yellow" }}>
        Terms & Conditions
      </span>
    </span>
  </div>
</div>


                 {/* 🔥 APPROVE BUTTON */}
           {!isApproved && (
            <button
              onClick={handleApprove}
              className="button-animation"
              disabled={approving}
            >
              <span>{approving ? "Approving..." : "Approve"}</span>
            </button>
          )}

            {/* 🔥 REGISTER BUTTON */}
            {isApproved && (
              <button onClick={handleRegister} className="button-animation">
                <span>Register</span>
              </button>
            )}
              
            </div>

          </div >
          <div className="or-text">
            <span>Or</span>
          </div>

          <div className="link-rg">
            Already have an account?
            <Link to="/" className="ms-2">Login</Link>
          </div>
        </div >
        {showTerms && (
  <div className="terms-overlay">
    <div className="terms-modal">
      <TermCondition
        onAccept={() => {
          setAcceptTerms(true);
          setShowTerms(false);
        }}
        onClose={() => setShowTerms(false)}
      />
    </div>
  </div>
)}
      </div >
    </>
  );
};

export default Register;
